<div class="p-2 bg-gray-200 rounded text-center text-sm">
    18+. Odds correct at time of publishing and subject to change.
</div>